<!-- =========================================================================================
    File Name: Home.vue
    Description: Home Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="vx-col lg:w-full sm:m-0 m-4">
    <div slot="no-body" class="full-page-bg-color event-inactive">
      <vx-card class="home-card">
        <div class="vx-row no-gutter justify-center items-center">
          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-full d-theme-dark-bg">
            <div class="p-8 login-tabs-container">
              <div class="vx-col hidden lg:block lg:w-full">
                <img
                  v-if=" customLogo != '' "
                  :src="customLogo"
                  alt="login"
                  class="mx-auto event-img"
                />
                <img
                  v-else
                  src="@/assets/images/pages/maintenance-2.png"
                  alt="login"
                  class="mx-auto event-img"
                />
              </div>
              <br />
              <div class="vx-card__title mb-4 justify-center items-center" v-if="timeDiff < 30">
                <h4 class="mb-4" style="text-align: center;">{{$t('WelcomeEvent')}} {{eventName}}</h4>
                <p style="text-align: center;">{{$t('EventMsg1')}}</p>
                <p style="text-align: center;">{{$t('EventMsg2')}}</p>
              </div>
              <div class="vx-card__title mb-4 justify-center items-center" v-else>
                <h4 class="mb-4" style="text-align: center;">{{$t('WelcomeEvent')}} {{eventName}}</h4>
                <p
                  style="text-align: center;"
                >{{$t('EventMsg3')}} {{eventName}} {{$t('EventMsg4')}} {{ eventDate |
                moment("DD/MM/YYYY") }} {{$t('All')}} {{ eventDate | moment("HH:mm")  }}.</p>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="conference-switch" style="display: none">
      <div class="vx-col flex mb-5" >
        <h5 class="mr-2">{{$t('VedioConference')}}</h5>
        <vs-switch v-model="switch_conference" v-on:change="toggleConference">
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-col w-full mb-5" id="external-conference" style="display: none;">
      <a href="https://concilium-2.zoom.us/j/4955313104?pwd=Q0c3VVMzS2YxTU9VZ1FJb0lIV1ZkQT09" target="_blank">{{$t('VideoConference1')}}</a>
    </div>

    <div class="conference" style="display:none">
      <div v-if="conference_link" class="container home-card" style="text-align: center">
        <iframe
          class="responsive-iframe"
          allow="microphone; camera"
          :src="conference_link"
          frameborder="0"
        ></iframe>
      </div>
      <div v-else class="container home-card" style="text-align: center">{{$t('ConferenceLink')}}</div>
      <br />
    </div>

    <div slot="no-body" class="full-page-bg-color event-active" style="display:none">
      <div v-if="eventVoting.length > 0 ">
        <div v-for="(vote,index) in eventVoting" :key="index">
          <vx-card class="home-card" style="margin-bottom:20px;" v-if="vote.status != 4 && vote.type == 'voting'">
            <h4>{{vote.voting_title}}</h4>
            <br />
            <div :id="'vote_' + vote.id">
              <p>
                <strong>{{$t('VotingTitle')}}: </strong>
                {{vote.voting_name}}
              </p>
              <p>
                <strong>{{$t('Description')}}: </strong>
                <span v-html="vote.voting_description"></span>
              </p>
              <div style="margin-top:10px" :id="'hid_btn_' + vote.id">
                <div v-if="vote.status == 2" style>
                  <vs-button disabled>{{$t('VotingClosed')}}</vs-button>
                </div>
                <div v-else-if="vote.status == 0 " style>
                  <vs-button class="vs-button-primary" disabled>{{ $t('VotingNotOpen') }}</vs-button>
                </div>
                <div v-else-if="vote.status == 1">
                  <vs-button style="font-size: 20px;" @click="handleVoting(vote.id, vote.type_of_voting)">{{$t('VoteNow')}}</vs-button>
                </div>
              </div>
              <div v-if="vote.status == 1 && vote.type_of_voting == 3" :id="'vote_yes_'+ vote.id" style="padding: 10px 0px; display:none">
                <!--normal flow-->
                  <div style="display:inline-block;margin-right:10px">
                    <vs-button style="margin-right: 10px;margin-top: 10px;" disabled>{{$t('Yes')}}</vs-button>
                    <vs-button style="margin-right: 10px;margin-top: 10px;" disabled>{{$t('No')}}</vs-button>
                    <vs-button v-if="vote.is_secret == 1" style="margin-right: 10px;margin-top: 10px;" disabled>{{$t('Abstained')}}</vs-button>
                  </div>
                <br />
                <br />
              </div>
              <div v-if="vote.status == 1 && candidates.length > 0 && vote.type_of_voting == 1" :id="'vote_candidate_'+ vote.id" style="padding: 10px 0px;display:none">
                <!--normal flow-->
                  <div>
                    <table class="candidate-names" style="text-align: left !important;">
                      <tbody>
                        <tr v-for="(candidate,key) in candidates[vote.id]" :key="key">
                          <td class="float-left">{{candidate.candidate_name}}</td>
                          <td>
                            <vs-checkbox
                              class="float-right"
                              v-model="checkBox1[vote.id]"
                              :vs-value="candidate.id"
                            ></vs-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      <br />
                      <vs-button disabled>{{$t('Submit')}}</vs-button>
                    </div>
                  </div>
                <br />
                <br />
              </div>
               <!--Option type voting-->
              <div v-if="vote.status == 1 && options.length > 0 && vote.type_of_voting == 2" :id="'vote_option_'+ vote.id" style="padding: 10px 0px;display:none">
                  <!--normal flow-->
                  <div>
                    <table style="text-align: left !important;">
                      <tbody>
                        <tr v-for="(option,key) in options[vote.id]" :key="key">
                          <td>
                            <div>
                              <vs-button disabled>
                                {{$t(option.options)}}
                              </vs-button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
               <!--Option type voting-->
            </div>
          </vx-card>
           <vx-card class="home-card" style="margin-bottom:20px;" v-else-if="vote.type == 'agenda'">
              <p class="mb-2">
              <strong>{{vote.title}}</strong>
              </p>
              <p class="mb-2">
                <strong>Topic: </strong>
                {{vote.name}}
              </p>
              <p class="mb-1">
                <strong>Description: </strong>
                <span v-html="vote.description"></span>
              </p>
              <div class="float-right">
                <strong>Attachments: </strong> <br>
                <div v-for="(attach, index2) in vote.attachment.split(',')" :key="index2">
                    <a :href="eventInfo.event_agenda_path + '/'+ vote.id + '/' + attach" type="download" target="_blank">{{attach}}</a>
                </div>
              </div>
              <br><br>
              <br><br>
          </vx-card>
        </div>
      </div>
    </div>

    <div slot="no-body" class="full-page-bg-color vote-publish" v-if="eventVotingPublish.length > 0">
      <div class="vx-row">
          <table class="vx-col lg:w-full">
            <tbody>
             <tr v-for="(vote,index) in eventVotingPublish" :key="index">
                <td valign="top" class="vx-col w-1/2 md:w-1/2 lg:w-full xl:w-1/2 mb-base" style="padding-right:10px">
                  <vx-card>
                    <h4>{{vote.voting_title}}</h4>
                    <br />
                    <div :id="'vote_' + vote.id">
                      <p>
                        <strong>{{$t('VotingTitle')}}: </strong>
                        {{vote.voting_name}}
                      </p>
                      <p>
                        <strong>{{$t('Description')}}: </strong>
                        <span v-html="vote.voting_description"></span>
                      </p>
                      <!--p>
                        <strong>{{$t('Date')}}: </strong>
                        {{vote.voting_end_date }}
                      </p-->
                       <p>
                        <strong>{{$t('Vote')}}: </strong>
                        {{vote.is_secret == 0 ? $t('NonSecret') : $t('Secret') }}
                      </p>
                       <p>
                        <strong>{{$t('QuorumType')}}: </strong>
                        {{vote.quorum_type_ita}}
                      </p>
                      <br />
                      <p>
                        <strong>{{$t('Quorum')}}: </strong>
                        <span
                          v-if="vote.quorum == true"
                          style="border-radius: 50px;background-color:green;padding: 5px 14px;color:#fff"
                        >{{$t('Passed')}}</span>
                        <span
                          v-else-if="vote.no_votes == vote.yes_votes"
                          style="border-radius: 50px;background-color:red; padding: 5px 14px;color:#fff"
                        >{{$t('Parity')}}</span>
                        <span
                          v-else
                          style="border-radius: 50px;background-color:red; padding: 5px 14px;color:#fff"
                        >{{$t('Failed')}}</span>
                      </p>
                      <br />
                      <p>
                        <span
                          class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-success"
                          style="display:inline-block"
                        />
                        <span>{{$t('Present')}} : {{ vote.present ? vote.present : 0 }}</span>
                      </p>
                      <!--p>
                            <span class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-warning" style="display:inline-block"/>
                            <span>Delegated  : {{vote.voted }}</span>
                      </p>-->
                      <p>
                        <span
                          class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-primary"
                          style="display:inline-block"
                        />
                        <span>{{$t('TotalNominal')}} : {{vote.voted }}</span>
                      </p>
                      <p v-if="vote.winning_option && vote.type_of_voting != 1">
                        <span
                          class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-primary"
                          style="display:inline-block"
                        />
                      <span>{{$t('WiningOption')}}: {{ $t(vote.winning_option)}}</span>
                      </p>
                      <br />
                      <p v-if="vote.is_secret == 0">
                        <span @click="openDetails(vote.id)" style="cursor: pointer;">{{$t('VotingInfo')}}</span>
                      </p>
                      <p>
                        <br />
                        <strong>{{$t('Result')}}: </strong>
                        <span
                          v-if="(vote.quorum == true && vote.winning_option === 'Yes') || vote.type_of_voting == 1"
                          style="border-radius: 50px;background-color:green;padding: 5px 14px;color:#fff;margin-left:10px;"
                        >{{$t('Approved')}}</span>
                        <span
                          v-else
                          style="border-radius: 50px;background-color:red; padding: 5px 14px;color:#fff;margin-left:10px;"
                        >{{$t('Rejected')}}</span>
                      </p>
                    </div>
                  </vx-card>
                </td>
                <td valign="top" class="vx-col w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base" style="padding-left:10px">
                  <vx-card v-if="vote.type_of_voting == 3">
                    <h4>{{$t('Preferences')}}</h4>
                    <br />
                    <p>
                      {{$t('Yes')}} :
                      <span class="float-right">{{vote.yes_votes}}</span>
                      <br />
                      <strong>{{parseInt(vote.voted) > 0 ? (Math.round((vote.yes_votes / vote.voted * 100 ) * 100) / 100).toFixed(2) : '0.00' }}%</strong>
                      <vs-progress
                        class="block mt-1"
                        :percent="parseInt(Math.round((vote.yes_votes / vote.voted * 100 ) * 100) / 100)"
                        color="primary"
                      ></vs-progress>
                    </p>
                    <br />
                    <p>
                      {{$t('No')}} :
                      <span class="float-right">{{vote.no_votes}}</span>
                      <br />
                      <strong>{{parseInt(vote.voted) > 0 ? (Math.round((vote.no_votes / vote.voted * 100 ) * 100) / 100).toFixed(2) : '0.00'}}%</strong>
                      <vs-progress
                        class="block mt-1"
                        :percent="parseInt(Math.round((vote.no_votes / vote.voted * 100 ) * 100) / 100)"
                        color="primary"
                      ></vs-progress>
                    </p>
                    <br />
                    <p v-if="vote.is_secret == 1">
                      {{$t('Abstained')}} :
                      <span class="float-right">{{vote.abstained}}</span>
                      <br />
                      <strong>{{parseInt(vote.voted) > 0 ? (Math.round((vote.abstained / vote.voted * 100 ) * 100) / 100).toFixed(2): '0.00'}}%</strong>
                      <vs-progress
                        class="block mt-1"
                        :percent="parseInt(Math.round((vote.abstained / vote.voted * 100 ) * 100) / 100)"
                        color="primary"
                      ></vs-progress>
                    </p>
                  </vx-card>
                  <vx-card v-if="vote.type_of_voting == 1">
                    <h4>{{$t('ElectedCandidates')}}</h4>
                    <br />
                    <table class="candidate-result" style="text-align: left !important;">
                      <tbody>
                        <tr v-for="(candidate,key) in candidateResult[vote.id]" :key="key">
                          <td class="float-left">{{candidate.candidate_name}}</td>
                          <td>
                            <span class="float-right">{{candidate.total_votes}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </vx-card>
                   <vx-card v-if="vote.type_of_voting == 2">
                    <h4>{{$t('Preferences')}}</h4>
                    <br />
                    <div v-for="(option,key) in optionResult[vote.id]" :key="key">
                      <p>
                        {{$t(option.options)}} :
                        <span class="float-right">{{option.total_votes}}</span>
                        <br />
                        <strong>{{parseInt(vote.voted) > 0 ? (Math.round((option.total_votes / vote.voted * 100 ) * 100) / 100).toFixed(2) : '0.00' }}%</strong>
                        <vs-progress
                          class="block mt-1"
                          :percent="parseInt(Math.round((option.total_votes / vote.voted * 100 ) * 100) / 100)"
                          color="primary"
                        ></vs-progress>
                      </p>
                      <br />
                    </div>                    
                  </vx-card>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>

    <div class="voting-not-stated" style="display:none">
      <vx-card class="home-card"><h4>{{$t('VotingNotStarted')}}</h4></vx-card>
    </div>

    <div slot="no-body" class="full-page-bg-color event-done" style="display:none">
      <vx-card class="home-card">
        <div class="vx-row no-gutter justify-center items-center">
          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-full d-theme-dark-bg">
            <div class="p-8 login-tabs-container">
              <div class="vx-col hidden lg:block lg:w-full">
                <img
                  v-if=" customClosedLogo != '' "
                  :src="customClosedLogo"
                  alt="login"
                  class="mx-auto event-img"
                />
                <img
                  v-else
                  src="@/assets/images/pages/maintenance-2.png"
                  alt="login"
                  class="mx-auto event-img"
                />
              </div>
              <br />
              <div class="vx-card__title mb-4 justify-center items-center">
                <h4 class="mb-4" style="text-align: center;">{{$t('WelcomeEvent')}} {{eventName}}</h4>
                <p style="text-align: center;">{{$t('EventDone')}}</p>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <vs-popup class="holamundo" :title="$t('UsersVoted')" :active.sync="popupActive2">
      <vs-table :data="userList" pagination :max-items="10" search>
        <template slot="thead">
          <vs-th>{{$t('FirstName')}}</vs-th>
          <vs-th>{{$t('LastName')}}</vs-th>
          <vs-th>{{$t('IdNumber')}}</vs-th>
          <vs-th>{{$t('Voted')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].first_name">{{data[indextr].first_name}}</vs-td>
            <vs-td :data="data[indextr].last_name">{{data[indextr].last_name}}</vs-td>
            <vs-td :data="data[indextr].id_number">{{data[indextr].id_number}}</vs-td>
            <vs-td :data="data[indextr].value" v-if="currentVotingType == 1">
              {{ data[indextr].value.join(', ') }}
            </vs-td>
            <vs-td :data="data[indextr].value" v-if="currentVotingType == 3">
              {{ data[indextr].value == 1 ? $t('Yes') : ( data[indextr].value == 0 ? $t('No') : $t('Abstained')) }}
            </vs-td>
            <vs-td :data="data[indextr].value" v-if="currentVotingType == 2">
              {{ $t(data[indextr].value.join(', ')) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <audio :src="audioURL" id="backgroundAudio" muted autoplay/>
    <audio src="@/assets/audio/speech.mp3" id="eventStartAudio" muted/>
  </div>
</template>
<style lang="scss">
.candidate-names, .option-names {
  border-collapse: collapse;
  border-spacing: 0;
}

th, td {
  text-align: left;
  padding: 10px;
}

.candidate-names tr:nth-child(even) {
  background-color: #ECECEC;
}

.option-names tr:nth-child(even) {
  background-color: #ECECEC;
}

/* start by luca */
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: unset;
  border-radius: 5px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  max-height: 600px;
  max-width: unset;
}

@media only screen and (max-width: 992px) {
  .conference .home-card {
    height: 600px;
  }
}

@media (min-width: 576px) {
  .container {
    max-width: unset;
    height: 600px;
  }
}

/* end by luca */

.event-img {
  max-width: 600px;
}

.candidate-names td, .candidate-result td, .option-names td {
  margin-bottom: 7px;
  margin-right: 170px;
}

.btn-link {
  width: 100% !important;
  height: 600px !important;
  background: rgb(71, 70, 70) !important;
  box-shadow: rgb(71, 70, 70) 0px 3px 0px 0px;
}
.vs-dialog {
  max-width: 660px !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 0px !important;
}
.hide-div {
  display: none;
}

@media only screen and (max-width: 992px) {
  .home-card {
    margin-left: 0px;
  }
}
.vs-button-flat,
.vs-button-flat:hover {
  background-color: #7367f0 !important;
  color: #fff !important;
}
.vs-dialog .vs-button {
  margin-right: 20px !important;
  text-align: center;
}
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>

<script>
import $ from "jquery";
import moment from "moment";

export default {
  data() {
    return {
      eventName: "",
      eventInfo: [],
      event_id: "",
      user_id: "",
      statusCheck: "",
      eventVoting: "",
      userVoting: [],
      current_voting_id: "",
      conference_link: "#",
      ipAddress: "",
      slug: "",
      currentUser: "",
      express: [],
      isLoggedInDone: false,
      eventVotingPublish: [],
      checkBox1: [],
      radioBox:[],
      parentIds: [],
      userVotedList: [],
      popupActive2: false,
      userList: [],
      candidates: [],
      options: [],
      candidateResult: [],
      timeDiff:"",
      eventDate: '',
      confirmation_vote:"",
      switch_conference: true,
      showConference: false,
      delegeted_for: [],
      isSingelVote: [],
      showDelegete: [],
      delegeted: [],
      allVoted: [],
      currentExpressVote: '',
      showCard: [],
      is_ghost: '',
      optionResult: [],
      votedType: [],
      currentVotingType: '',
      customLogo: '',
      customClosedLogo: '',
			audioURL: null,
    };
  },
  beforeMount() {
    this.slug = this.$route.params.slug;
    this.currentUser = this.$store.getters.currentUser;
    this.user_id = this.currentUser.id;
    this.getEventId();
  },
  mounted(){
		this.handleBackgroundMp3Assets();
    this.handleAssets()
    this.handleClosedEventAssets()
  },
  created() {
    clearInterval(this.statusCheck);

    fetch("https://api.ipify.org?format=json")
      .then(x => x.json())
      .then(({ ip }) => {
        this.ipAddress = ip;
      });
  },
  beforeDestroy() {
    clearInterval(this.statusCheck);
    this.statusCheck = "";
  },
  methods: {
    /**
     * open popup
     * @author Madhura Shah
     */
    openDetails(id) {
      this.userList = [];
      this.userList = this.userVotedList[id];
      this.currentVotingType = this.votedType[id];
      this.popupActive2 = true;
    },
   
    /**
     * Handle Voting
     * @author Madhura Shah
     */
    handleVoting(id, type_of_voting) {
      $("#hid_btn_" + id).hide();
      if (type_of_voting == 3) {
        $("#vote_yes_" + id).show();
      }  else if(type_of_voting == 1){
        $("#vote_candidate_" + id).show();
      } else if(type_of_voting == 2) {
        $("#vote_option_" + id).show();
      }
    },
		/**
     * Get background mp3
     * @author Bhagwan Sawant
     */
		async handleBackgroundMp3Assets() {
			this.$vs.loading()
			try{
				const response = await this.$store.dispatch("GetAssets", "background_mp3")
				this.audioURL = response.data.data.path;
			}catch(error) {
        console.error(error);
				this.$vs.notify({
					title: this.$t('FailedToConfigureAssets'),
					text: error,
					color: "danger",
					position: "top-center",
				});
			}
			this.$vs.loading.close();
    },

    /**
     * Get event info
     * @author Madhura Shah
     */
    getEventId() {
      this.$vs.loading();
      var data = {
        slug : this.slug,
        user_id: this.user_id
      }
      this.$store
        .dispatch("getEventId", data)
        .then(res => {
          var data = res.data.data;
          this.event_id = data.id;
          this.eventName = res.data.data.event_name;
          this.eventDate = res.data.data.event_start_date;
          //this.timeDiff = moment.utc(moment(new Date(this.eventDate),"DD/MM/YYYY HH:mm:ss").diff(moment(new Date(),"DD/MM/YYYY HH:mm:ss"))).format("mm")
          var now = moment(new Date(), "DD/MM/YYYY HH:mm:ss");
          var then = moment(new Date(this.eventDate), "DD/MM/YYYY HH:mm:ss");

          var ms = moment(then, "DD/MM/YYYY HH:mm:ss").diff(
            moment(now, "DD/MM/YYYY HH:mm:ss")
          );
          var d = moment.duration(ms);
          this.timeDiff = Math.floor(d.asHours()) + moment.utc(ms).format("mm");

          if(res.data.data.status == 0) {
             $('#backgroundAudio')[0].play();
          }

          this.getEventStatus();
          // var polling_freq = res.data.data.polling_freq + '000';
          // this.statusCheck = setInterval(() => {
          //   this.getEventStatus();
          // }, polling_freq);
           Echo.channel('eventStatus' + this.event_id)
              .listen('EventStatus', response => {
                console.log('call');
                  this.getEventStatus();
            })
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : Event.vue | Function : getEventId() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("EventLoadError"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },

    /**
     * Get event status (called this function every 5 sec)
     * @author Madhura Shah
     */
    getEventStatus(end_voting_id = null) {
      // check event status
      if (this.event_id && this.user_id) {
        var data = {
          event_id: this.event_id,
          user_id: this.user_id
        };
        this.$store
          .dispatch("getEventStatus", data)
          .then(res => {
            if (res.data.data) {
              $(".event-inactive").hide();
              $(".no-rights-vote").hide();
              $(".event-active").hide();
              $(".event-done").hide();
              $(".event-active").hide();
              $(".vote-publish").hide();
              $('.voting-not-stated').hide();
              this.confirmation_vote = res.data.data.confirmation_vote
              if (res.data.data.status == 1 ||  res.data.data.status == 3) {
                if(this.showConference == false) {
                  $(".conference").show();
                  $(".conference-switch").show();
                  this.showConference = true
                }
                $(".event-active").show();
                $(".vote-publish").show();
                // clearInterval
                this.eventVoting = [];
                if (res.data.data.event_details) {
                  this.eventInfo = res.data.data.event_details;
                  this.conference_link = this.eventInfo.conference_link;
                  this.conference_link = this.conference_link ? this.conference_link + "&full_name=" + this.$store.getters.currentUser.first_name + " " + this.$store.getters.currentUser.last_name : '';

                  if(this.eventInfo.status == 1 && this.isPlayed != true) {
                      $('#backgroundAudio')[0].pause();
                      $('#eventStartAudio')[0].play();
                      this.isPlayed = true; 
                  }

                  var eventVoting = this.eventInfo.event_voting;
                  this.delegeted_for = this.eventInfo.delegeted_for;
                  var i = 0;
                  var j = 1;
                  this.eventVotingPublish = [];
                  this.eventVoting = [];
                  this.parentIds = [];
                  var startedId = [];
                  var parentIds = [];
                  var hideVote = [];
                  var endVoteId = "";

                  // get parrent ids
                  eventVoting.forEach(evote => {
                    if (evote.parent_id != null && evote.status == 1) {
                      parentIds.push(evote.parent_id);
                      startedId.push(evote.id);
                    } else if (
                      evote.parent_id != null &&
                      evote.status != 1 &&
                      evote.status != 0
                    ) {
                      parentIds.push(evote.parent_id);
                      endVoteId = evote.id;
                    }
                  });

                  if (startedId.length > 0) {
                    endVoteId = "";
                  }

                  eventVoting.forEach(evote => {
                    
                   evote.type = evote.event_id !== undefined ? 'voting' : 'agenda';

                   if (evote.status == 3) {
                      if (
                        evote.parent_id == null ||
                        (evote.parent_id != null &&
                          startedId.length == 0 &&
                          endVoteId == evote.id)
                      ) {
                        if (!parentIds.includes(evote.id)) {
                          this.eventVotingPublish[i] = evote;
                          this.eventVotingPublish[i]["voting_no"] = i;
                          if (evote.user_votings !== undefined) {
                            this.userVotedList[evote.id] = evote.user_votings;
                            this.votedType[evote.id] = evote.type_of_voting;
                          }
                          if (evote.electedCandidates !== undefined) {
                            this.candidateResult[evote.id] = evote.electedCandidates;
                          }
                           
                          if (evote.option_votes !== undefined) {
                            this.optionResult[evote.id] = evote.option_votes;
                          }
                          
                          i++;
                        }
                      }
                    } else if (evote.status != 0) {
                      if (evote.parent_id == null || (evote.parent_id != null && (startedId.includes(evote.id) || endVoteId == evote.id))) {
                        if (!parentIds.includes(evote.id)) {
                          this.eventVoting[i] = evote;
                          this.eventVoting[i]["voting_no"] = i;
                          i++;
                          if (evote.candidates != undefined) {
                            this.candidates[evote.id] = evote.candidates;
                            this.checkBox1[evote.id] = this.checkBox1[evote.id] !== undefined ? this.checkBox1[evote.id] : []
                          }

                          if(evote.options !== undefined) {
                            this.options[evote.id] = evote.options;
                            this.radioBox[evote.id] = this.radioBox[evote.id] !== undefined ? this.radioBox[evote.id] : []
                          }

                          this.userVoting[evote.id] = []
                          if (evote.user_votings) {
                            var user_voting = evote.user_votings;
                            user_voting.forEach(voted => {
                              var id = voted.user_id ? voted.user_id : voted.id
                              this.userVoting[evote.id].push(id)
                            });
                          }
                        }
                      }
                      
                      if(evote.status == 2) {
                             $("#hid_btn_" + evote.id).show();
                      }
                    }
                  });
                  
                  this.eventVoting = this.eventVoting.filter(item => item);
                  this.eventVotingPublish = this.eventVotingPublish.filter(item => item).reverse();

                  if (this.eventVoting.length == 0 && this.eventVotingPublish == 0) {
                    $(".voting-not-stated").show();
                  }
                }

              } else if (res.data.data.status == 0) {
                $(".event-inactive").show();
                $(".conference-switch").hide();
                $(".conference").hide();
                $("#external-conference").hide();
                this.showConference = false
              } else {
                $(".event-done").show();
                clearInterval(this.statusCheck);
              }
            }
          })
          .catch(error => {
            this.$log.error('File : Event.vue | Function : getEventStatus() | Error :', error);
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
              title: this.$t("EventInfoError"),
              text: error,
              color: "danger",
              position: "top-center"
            });
            return false;
          });
      } else {
        return false;
      }
    },

    /**
     * Redirect to conf
     * @author Madhura Shah
     */
    redirectToConf() {
      if (this.eventInfo.conference_link != null)
        window.location.href = this.eventInfo.conference_link;
    },

    /**
     * Voting card no
     * @author Madhura Shah
     */
    words(n) {
      var num = this.$t("VotingNo").split(" ");
      if (n <= 10) return num[n];
      return n;
    },

    toggleConference(event) {
        if (event.type == "change") {
            let conference = $(".conference");
            let external_conference = $("#external-conference");
            if (conference.is(":hidden")) {
                external_conference.hide();
                conference.show();
            } else {
                conference.hide();
                external_conference.show();
            }
        }
        return true;
    },

    handleAssets(){
        this.$store
        .dispatch("GetAssets","event_not_open")
        .then(response => {
            this.customLogo = response.data.data.path;
            this.$vs.loading.close();
        })
        .catch(error => {
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
                title: "Failed to configure assets",
                text: error,
                color: "danger",
                position: "top-center"
            });
            return false;
        });
    },

    handleClosedEventAssets(){
        this.$store
        .dispatch("GetAssets","event_closed")
        .then(response => {
            this.customClosedLogo = response.data.data.path;
            this.$vs.loading.close();
        })
        .catch(error => {
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
                title: "Failed to configure assets",
                text: error,
                color: "danger",
                position: "top-center"
            });
            return false;
        });
    },

  }
};
</script>


